import { apiService } from "../api";
import { ApiResponse, Notification, PaginatedResponse } from "../../types";

export interface GetUserNotificationsParams {
  status?: "all" | "unread" | "read" | "archived";
  priority?: "low" | "medium" | "high" | "urgent";
  category?: string;
  page?: number;
  limit?: number;
}

export interface NotificationStats {
  total: number;
  unread: number;
  read: number;
  archived: number;
}

export const getUserNotifications = async (
  params: GetUserNotificationsParams = {}
): Promise<{
  success: boolean;
  data: Notification[];
  pagination?: PaginatedResponse["pagination"];
  stats?: NotificationStats;
}> => {
  const response = await apiService.get("/inapp-notifications/user", {
    params,
  });
  return response.data;
};

export const getNotificationStats = async (): Promise<
  ApiResponse<{ stats: NotificationStats }>
> => {
  const response = await apiService.get("/inapp-notifications/stats");
  return response.data;
};

export const markNotificationRead = async (
  notificationId: string
): Promise<ApiResponse> => {
  const response = await apiService.put("/inapp-notifications/mark-read", {
    notificationId,
  });
  return response.data;
};

export const markAllNotificationsRead = async (
  category?: string
): Promise<ApiResponse> => {
  const response = await apiService.put("/inapp-notifications/mark-read", {
    markAll: true,
    category,
  });
  return response.data;
};

export const archiveNotification = async (
  notificationId: string
): Promise<ApiResponse> => {
  const response = await apiService.put(
    `/inapp-notifications/${notificationId}/archive`
  );
  return response.data;
};
